import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ActionResultBoolean } from '@portal/models/actionResultBoolean';
import { ImageWrapperShared } from '@portal/models/imageWrapperShared';
import { ContentTypeEnum, getMultipartFormData, replaceId } from '@portal/core';
import { clientContext } from '../client.context';

@Injectable({
  providedIn: 'root',
})
export class CompaniesSharedImagesService {
  private readonly http = inject(HttpClient);

  upload(image: File, id: number, request?: number): Observable<ActionResultBoolean> {
    const payload = getMultipartFormData([
      { name: 'image', value: image },
      { name: 'request', value: { sortOrder: request } },
    ]);

    return this.http.post<ActionResultBoolean>(
      replaceId(clientContext.companies.uploadImage, id),
      payload,
      this.getMultipartHeaders,
    );
  }

  update(image: File, companyId: number, sortOrder: number, imageId: number): Observable<ActionResultBoolean> {
    const payload = getMultipartFormData([
      { name: 'image', value: image },
      { name: 'request', value: { sortOrder } },
    ]);

    return this.http.put<ActionResultBoolean>(
      this.replaceIdAndImageId(clientContext.companies.updateImage, companyId, imageId),
      payload,
      this.getMultipartHeaders,
    );
  }

  delete(imageId: number, companyId: number): Observable<ActionResultBoolean> {
    return this.http.delete<ActionResultBoolean>(
      this.replaceIdAndImageId(clientContext.companies.deleteImage, companyId, imageId),
    );
  }

  changeMeta(image: ImageWrapperShared, order: number, itemId: number): Observable<ActionResultBoolean> {
    const payload = getMultipartFormData([
      { name: 'request', value: { sortOrder: order, altAttribute: image.altAttribute, metaTitle: image.metaTitle } },
    ]);

    return this.http.put<ActionResultBoolean>(
      this.replaceIdAndImageId(clientContext.companies.updateImage, itemId, image.id),
      payload,
      this.getMultipartHeaders,
    );
  }

  get getMultipartHeaders() {
    return { headers: { 'Content-Type': ContentTypeEnum.MultipartForm } };
  }

  private replaceIdAndImageId(url: string, id: number, imageId: number) {
    return replaceId(url, id).replace('{imageId}', `${imageId}`);
  }
}
